module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image20.541d614e.webp";